import { Box, Container, Divider, HStack, Img, SimpleGrid, Text, VStack } from "@chakra-ui/react";

export function FooterHome() {
    return (
        <Container maxW={"auto"} width="-webkit-fit-content" centerContent>
            <HStack padding={"50px"} align={"center"} width="92%">
                <SimpleGrid columns={[2, 3, 4, 4]} spacing={5} marginX="50px" width={"65%"} justifyContent={"flex-start"}>
                    <Box padding="5">
                        <Img src="https://static.naukimg.com/s/4/100/i/naukri_Logo.png" maxW={"100%"} marginY="2" />
                        <Text size={1} color="#8292b4" marginTop="4">Connect With us</Text>
                        <HStack maxW={"max-content"} spacing="3" marginY="2" >
                            <Img maxW={"20px"} src="https://i.ibb.co/LSLXHws/facebook.png" alt="fb" />
                            <Img maxW={"20px"} src="https://i.ibb.co/8KhcSJr/instagram.png" alt="insta" />
                            <Img maxW={"20px"} src="https://i.ibb.co/BTDGYCZ/linkedin-logo.png" alt="linkedin" />
                            <Img maxW={"20px"} src="https://i.ibb.co/VNMQT0m/twitter-sign.png" alt="twitter" />
                        </HStack>
                    </Box>
                    <Box padding={"4"} >
                        <VStack maxW={"md"} align={"start"}>
                            <p color="#8292b4" >About Us</p>
                            <p color="#8292b4" >Careers </p>
                            <p color="#8292b4" >Employee Home</p>
                            <p color="#8292b4" >Sitemap</p>
                        </VStack>
                    </Box>
                    <Box padding={"4"} >
                        <VStack maxW={"md"} align={"start"}>
                            <p color="#8292b4" >Help Center</p>
                            <p color="#8292b4" >Summons/Notices </p>
                            <p color="#8292b4" >Grievances</p>
                            <p color="#8292b4" >Report Issue</p>
                        </VStack>
                    </Box>
                    <Box padding={"4"} maxW={"-moz-fit-content"}>
                        <VStack maxW={"md"} align={"start"}>
                            <p color="#8292b4" >Privacy Policy</p>
                            <p color="#8292b4" >Terms and Conditions</p>
                            <p color="#8292b4" >Fraud alert</p>
                            <p color="#8292b4" >Trust And Safety</p>
                        </VStack>
                    </Box>
                </SimpleGrid>
                <Box padding={"4"} border={"1px solid #8292b4"} borderRadius="10" maxW={"fit-content"}>
                    <VStack margin={2} align="start" >
                        <Text fontWeight={900}>Apply on the Go</Text>
                        <Text>Get real-time job updates on our App</Text>
                    </VStack>
                    <HStack margin={2} padding={1}>
                        <Img src="https://static.naukimg.com/s/0/0/i/new-homepage/android-app.png" alt="play store" maxW={"50%"} ></Img>
                        <Img src="https://static.naukimg.com/s/0/0/i/new-homepage/ios-app.png" alt="apple store" width={"50%"} ></Img>
                    </HStack>
                </Box>
            </HStack >
            <Divider width={"90%"} color="#8292b4" />
            <HStack padding={2} justifyContent="center">
                <Img src="https://static.naukimg.com/s/0/0/i/new-homepage/infoedge-logo.svg" alt="infobadge" />
                <VStack padding={2} align={"start"}>
                    <Text fontSize={"13px"}>All trademarks are the property of their respective owners</Text>
                    <Text fontSize={"13px"}>All rights reserved © 2022 Info Edge (India) Ltd.</Text>
                </VStack>
                <Text paddingLeft={10} fontSize={"15px"} fontWeight={"500"}>Our businesses</Text>
                <HStack width={"50%"} overflowX={"hidden"}>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/nnacres.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/jeevansathi.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/ng.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/firstNaukri.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/shiksha.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/iimjobs.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/hirist.png" alt=""></Img>
                    <Img width={"60%"} src="https://static.naukimg.com/s/0/0/i/new-homepage/footer-logos/jobhai.png" alt=""></Img>
                </HStack>
            </HStack>

        </Container >

    )
}